// src/hooks/useUserData.js
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUserData } from "../../states/userSlice/userSlice";
import TokenDetails from "./useTokenDetails";

const useUserData = (props) => {
  const tokenDetails = TokenDetails();
  const userData = useSelector(selectUserData);
  const [data, setData] = useState({});

  useEffect(() => {
    try {
      const baseData =
        userData && Object.keys(userData).length > 0 ? { ...userData } : {};

      if (tokenDetails && Object.keys(tokenDetails).length > 0) {
        setData({ ...baseData, ...tokenDetails });
      } else {
        setData(baseData || {});
      }
    } catch (error) {
      console.error("Error retrieving user data:", error);
      if (tokenDetails && Object.keys(tokenDetails).length > 0) {
        setData({ ...tokenDetails });
      } else {
        setData({});
      }
    } finally {
      if (props?.setLoading) {
        props.setLoading(false);
      }
    }
  }, [userData]);

  return data;
};

export default useUserData;
